import { Group, Text } from '@mantine/core';

/**
 * Renders a list of items with a delimiter between them. The delimiter sits outside
 * each rendered item (so it isn't part of a link or tooltip) and stays on the same
 * line as the item before it when the list wraps.
 *
 * @param {Array} items - the values to render
 * @param {Function} renderItem - (item, index) => node; defaults to the item itself
 * @param {string} delimiter - text placed after every item but the last
 */
const DelimitedList = ({ items = [], renderItem = (item) => item, delimiter = ',' }) => (
    <Group spacing={4}>
        {items.map((item, idx) => (
            <Group key={idx} spacing={0} noWrap>
                {renderItem(item, idx)}
                {idx < items.length - 1 ? <Text size='sm'>{delimiter}</Text> : null}
            </Group>
        ))}
    </Group>
);

export default DelimitedList;
